import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import userPic from '../../../images/user.png';
import { depositToClientAccount } from '../../../actions/terminal';

import './style.scss';

const TransferToAccountDetails = ({ client }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Transfer to Account')}</h3>
      <div className="popup-main-content">
        <div className="client-info">
          <img alt="user-icon" src={userPic} />
          <div>
            <p>
              {client.FirstName}

              {client.LastName}
            </p>
            <p>{client.Id}</p>
          </div>
        </div>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={closePopup}
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={() => dispatch(depositToClientAccount(client.Id))}
        >
          {t('Submit')}
        </button>
      </div>
    </div>
    // <div className="transfer-to-account-details-container">
    //   <div className="transfer-to-account-details-title">{t('Transfer to Account')}</div>
    //   <div className="client-info">
    //     <img alt="user-icon" src={userPic} />
    //     <div>
    //       <p>
    //         asdsa
    //         {/* {client.FirstName} */}
    //         {' '}
    //         {/* {client.LastName} */}
    //       </p>
    //       {/* <p>{client.Id}</p> */}
    //       <p>safdlkslkfjsdkl</p>
    //     </div>
    //   </div>
    //
    // </div>
  );
};
export default TransferToAccountDetails;
